/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `I18nService`;

i18nStore.add(I18N_LANG_AR_AE, key, {});

i18nStore.add(I18N_LANG_EN_AU, key, {});

i18nStore.add(I18N_LANG_ZH_CN, key, {});
